"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const styles_1 = require("@mui/material/styles");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const chartOfAccountsSelectors_1 = require("companion-app-components/flux/chart-of-accounts/chartOfAccountsSelectors");
const selectors_1 = require("data/transactions/selectors");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const CategoryFieldEditable_1 = __importDefault(require("./CategoryFieldEditable"));
const helpers_1 = require("./helpers");
const STR_NOT_FOUND = 'NOTFOUND';
const CategoryField = (props) => {
    var _a;
    const theme = (0, styles_1.useTheme)();
    const { editable, clickable, classNameWhenNotEditable, name, noWrap, variant = 'body2', disableTooltip = false, } = props;
    const coaNodesById = (0, react_redux_1.useSelector)((state) => (0, chartOfAccountsSelectors_1.getChartOfAccountNodesById)(state, props));
    const isTransferAccountPresent = (0, react_redux_1.useSelector)((state) => (0, selectors_1.isTransferAccountAvailable)(state, props.txn));
    const getCoaNode = (0, react_1.useCallback)((coaId) => {
        let ret = coaNodesById ? coaNodesById.get(coaId) : null;
        if (chart_of_accounts_1.chartOfAccountsUtils.isTransferCoaNotFound(props.value)) {
            ret = coaNodesById.get(chart_of_accounts_1.chartOfAccountsUtils.TRANSFER_NOT_FOUND_COA_ID);
        }
        return ret;
    }, [coaNodesById, props.value]);
    const makeTransferName = (0, react_1.useCallback)((val) => `${theme.components.register.transferDelimeter1}${val}${theme.components.register.transferDelimeter2}`, [theme]);
    const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(props.value, props.allowBlank); // allow blank
    const coaNode = getCoaNode(coaId);
    const [state, setState] = (0, react_1.useState)({
        tfValue: coaId === 'BLANK' ? '' : (0, helpers_1.getDisplayName)(STR_NOT_FOUND, props.longCats, coaNode),
        isTransfer: (0, helpers_1.isTransfer)(coaNode),
    });
    const toolTipTitle = state.isTransfer ? makeTransferName(state.tfValue) : state.tfValue;
    const Wrap = disableTooltip ? react_1.default.Fragment : QTip_1.default;
    const wrapProps = disableTooltip ? {} : { wrapOnly: true, title: props.tooltip ? toolTipTitle : null };
    const prevValue = (0, react_use_1.usePrevious)(props.value);
    const prevCoaNodesById = (0, react_use_1.usePrevious)(coaNodesById);
    const prevLongCats = (0, react_use_1.usePrevious)(props.longCats);
    (0, react_1.useEffect)(() => {
        if (!coaNodesById) {
            return;
        }
        if (props.value !== prevValue
            || coaNodesById !== prevCoaNodesById
            || props.longCats !== prevLongCats) {
            const newCoaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(props.value, props.allowBlank);
            const newCoaNode = getCoaNode(newCoaId);
            // TODO: if coaNode cannot be found, set it to uncategorized coaNode
            if (newCoaNode) {
                setState({
                    isTransfer: (0, helpers_1.isTransfer)(newCoaNode),
                    tfValue: (0, helpers_1.getDisplayName)(STR_NOT_FOUND, props.longCats, newCoaNode),
                });
            }
            else {
                setState({
                    isTransfer: false,
                    tfValue: '',
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coaNodesById, prevCoaNodesById, prevValue, prevLongCats, props]);
    // CATEGORY type check is needed for split txns
    if (((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.type) !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY && !isTransferAccountPresent) {
        return (<QTypography_1.default sx={{ fontSize: props.fontSize || 'inherit' }} thinFont className={classNameWhenNotEditable}>
        [Transfer]
      </QTypography_1.default>);
    }
    return (<>
      {editable && (<CategoryFieldEditable_1.default sharedcomponentid="CATEGORY_FIELD" coaNodesById={coaNodesById} {...props}/>)}

      {!editable &&
            <Wrap {...wrapProps}>
          <QTypography_1.default variant={variant} clickable={clickable} className={classNameWhenNotEditable} sharedcomponentid="CATEGORY_FIELD" name={name} noWrap={noWrap}>
            {state.isTransfer ? makeTransferName(state.tfValue) : state.tfValue}
          </QTypography_1.default>
        </Wrap>}
    </>);
};
exports.default = (0, react_1.memo)(CategoryField);
